module.exports = __webpack_public_path__ + "img/rain.8cd9e689.svg";